import { render, staticRenderFns } from "./InactiveEmployeeShow.vue?vue&type=template&id=9e70649c&scoped=true&"
import script from "./InactiveEmployeeShow.vue?vue&type=script&lang=js&"
export * from "./InactiveEmployeeShow.vue?vue&type=script&lang=js&"
import style0 from "./InactiveEmployeeShow.vue?vue&type=style&index=0&id=9e70649c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e70649c",
  null
  
)

export default component.exports